import { Dispatch, SetStateAction, useEffect } from 'react';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useLocalStorage } from '@utils/hooks/index';
import { BASE_FRAME_NAMES, DEFAULT_BASE_FRAME_SHAPE } from '@constants';
import { evaluateEllaFrame } from '@utils/strings';

type BaseFrameShape = (typeof BASE_FRAME_NAMES)[number];

function useActiveFrame(
	defaultFrame: BaseFrameShape | 'Default Title' = DEFAULT_BASE_FRAME_SHAPE
): [BaseFrameShape, Dispatch<SetStateAction<BaseFrameShape>>] {
	const isEllaRename = useFeatureIsOn('is-ella-rename');
	const newFrame = defaultFrame === 'Default Title' || !defaultFrame ? DEFAULT_BASE_FRAME_SHAPE : defaultFrame;
	const [frame, setFrame] = useLocalStorage<BaseFrameShape>('activeFrame', evaluateEllaFrame(newFrame, isEllaRename));

	useEffect(() => {
		// TODO: clean hard-coded ella frame once the migration has been completed
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		if (frame === 'Ella' && isEllaRename) {
			setFrame((frame as BaseFrameShape).toLowerCase() as BaseFrameShape);
		}
	}, [isEllaRename]);

	return [frame, setFrame];
}

export default useActiveFrame;
